/**
 * @generated SignedSource<<3301169eb743b0b00b26ca57bad45580>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdateSubscriptionsInput = {
  clientMutationId?: string | null | undefined;
  data: SubscriptionInput;
  subscriptionManagerId: string;
};
export type SubscriptionInput = {
  country: string;
  documentsSubscribed: ReadonlyArray<TrancheWithSubscribedDocumentsInput | null | undefined>;
  preferredLanguage: string;
  priceInfoSubscribed: boolean;
  retailOnly?: boolean | null | undefined;
};
export type TrancheWithSubscribedDocumentsInput = {
  documents?: DocumentsSubscribedInput | null | undefined;
  trancheId: string;
};
export type DocumentsSubscribedInput = {
  all: boolean;
  factsheet: boolean;
  fpp: boolean;
  generalpublications: boolean;
  hjb: boolean;
  info: boolean;
  kid: boolean;
  prospect: boolean;
  publications: boolean;
  rb: boolean;
  taxtreat: boolean;
};
export type SubscriptionMutation$variables = {
  input: UpdateSubscriptionsInput;
  retailOnly: boolean;
  salesAdmission: string;
};
export type SubscriptionMutation$data = {
  readonly subscriptions: {
    readonly subscriptionManager: {
      readonly id: string;
      readonly priceinfo?: {
        readonly checked: boolean;
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"PriceInfo_component">;
      } | null | undefined;
      readonly subscriptiontable?: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"AboTable_table">;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type SubscriptionMutation = {
  response: SubscriptionMutation$data;
  variables: SubscriptionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "retailOnly"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "salesAdmission"
},
v3 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "kind": "Variable",
  "name": "salesAdmission",
  "variableName": "salesAdmission"
},
v6 = [
  {
    "kind": "Variable",
    "name": "retailOnly",
    "variableName": "retailOnly"
  },
  (v5/*: any*/)
],
v7 = [
  (v5/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "checked",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "col",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "TableHeader",
  "kind": "LinkedField",
  "name": "tableheader",
  "plural": true,
  "selections": [
    (v10/*: any*/),
    (v11/*: any*/)
  ],
  "storageKey": null
},
v13 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "all",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "kid",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "factsheet",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "publications",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "rb",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hjb",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "taxtreat",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fpp",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "info",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "prospect",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "generalpublications",
    "storageKey": null
  }
],
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "categoryname",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "CategoryInfo",
  "kind": "LinkedField",
  "name": "info",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CategoryInfoEntry",
      "kind": "LinkedField",
      "name": "entries",
      "plural": true,
      "selections": [
        (v11/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "value",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v17 = [
  (v11/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "filtervalue",
    "storageKey": null
  }
],
v18 = [
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "filtercategory",
    "plural": true,
    "selections": [
      (v9/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v10/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "DetailFilterItem",
            "kind": "LinkedField",
            "name": "filteritems",
            "plural": true,
            "selections": (v17/*: any*/),
            "storageKey": null
          }
        ],
        "type": "DetailFilterListCategory",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          (v10/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SelectBox",
            "kind": "LinkedField",
            "name": "selectbox",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SelectBoxItem",
                "kind": "LinkedField",
                "name": "options",
                "plural": true,
                "selections": [
                  (v14/*: any*/),
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "data",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "type": "DetailFilterDropdownCategory",
        "abstractKey": null
      },
      (v4/*: any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "DetailFilterSelectionInfo",
    "kind": "LinkedField",
    "name": "selectioninfo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "resetText",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "resultTextSingular",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "resultTextPlural",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  (v4/*: any*/)
],
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SubscriptionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "UpdateSubscriptionsPayload",
        "kind": "LinkedField",
        "name": "subscriptions",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "subscriptionManager",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": (v6/*: any*/),
                    "concreteType": "SubscriptionTable",
                    "kind": "LinkedField",
                    "name": "subscriptiontable",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "AboTable_table"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v7/*: any*/),
                    "concreteType": "PriceInfo",
                    "kind": "LinkedField",
                    "name": "priceinfo",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v8/*: any*/),
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "PriceInfo_component"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "SubscriptionManager",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "FundServiceMutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "SubscriptionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "UpdateSubscriptionsPayload",
        "kind": "LinkedField",
        "name": "subscriptions",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "subscriptionManager",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              (v4/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": (v6/*: any*/),
                    "concreteType": "SubscriptionTable",
                    "kind": "LinkedField",
                    "name": "subscriptiontable",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "DocumentsSubscribed",
                        "kind": "LinkedField",
                        "name": "documentheaders",
                        "plural": false,
                        "selections": (v13/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SubscriptionTranche",
                        "kind": "LinkedField",
                        "name": "entries",
                        "plural": true,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "fundsname",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isin",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "category",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "currency",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "salesadmission",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "distribution",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "institutional",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "traits",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "DocumentsSubscribed",
                            "kind": "LinkedField",
                            "name": "documents",
                            "plural": false,
                            "selections": (v13/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "DocumentLabels",
                        "kind": "LinkedField",
                        "name": "documentlabels",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "DocumentLabel",
                            "kind": "LinkedField",
                            "name": "labels",
                            "plural": true,
                            "selections": [
                              (v14/*: any*/),
                              (v11/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "shortlabel",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "documentLabelsTitle",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "furtherDocumentLabelsTitle",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "allDocumentLabelsTitle",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LiveFilter",
                        "kind": "LinkedField",
                        "name": "livefilter",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "placeholder",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "DetailFilter",
                        "kind": "LinkedField",
                        "name": "detailfilter",
                        "plural": false,
                        "selections": (v18/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "DetailFilter",
                        "kind": "LinkedField",
                        "name": "subscriptionfilter",
                        "plural": false,
                        "selections": (v18/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LanguagePreference",
                        "kind": "LinkedField",
                        "name": "languagepreference",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "currentselection",
                            "storageKey": null
                          },
                          (v16/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "DetailFilterItem",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": (v17/*: any*/),
                            "storageKey": null
                          },
                          (v15/*: any*/),
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "filterbuttontext",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "filterbuttontextexpanded",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "noResultsMessage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v7/*: any*/),
                    "concreteType": "PriceInfo",
                    "kind": "LinkedField",
                    "name": "priceinfo",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v8/*: any*/),
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FileLink",
                        "kind": "LinkedField",
                        "name": "file",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "header",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "text",
                            "storageKey": null
                          },
                          (v19/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "date",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "format",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "size",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "smallicon",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "largeicon",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SimpleLink",
                        "kind": "LinkedField",
                        "name": "archive",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          (v19/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "SubscriptionManager",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ecb3fdee08d2ddd8a6ad33f1d028769c",
    "id": null,
    "metadata": {},
    "name": "SubscriptionMutation",
    "operationKind": "mutation",
    "text": "mutation SubscriptionMutation(\n  $input: UpdateSubscriptionsInput!\n  $salesAdmission: String!\n  $retailOnly: Boolean!\n) {\n  subscriptions(input: $input) {\n    subscriptionManager {\n      __typename\n      id\n      ... on SubscriptionManager {\n        subscriptiontable(salesAdmission: $salesAdmission, retailOnly: $retailOnly) {\n          id\n          ...AboTable_table\n        }\n        priceinfo(salesAdmission: $salesAdmission) {\n          id\n          checked\n          ...PriceInfo_component\n        }\n      }\n    }\n  }\n}\n\nfragment AboHeader_header on SubscriptionTable {\n  tableheader {\n    col\n    label\n  }\n}\n\nfragment AboTable_table on SubscriptionTable {\n  ...AboHeader_header\n  documentheaders {\n    all\n    kid\n    factsheet\n    publications\n    rb\n    hjb\n    taxtreat\n    fpp\n    info\n    prospect\n    generalpublications\n  }\n  entries {\n    id\n    fundsname\n    isin\n    category\n    currency\n    salesadmission\n    distribution\n    institutional\n    traits\n    documents {\n      all\n      kid\n      factsheet\n      publications\n      rb\n      hjb\n      taxtreat\n      fpp\n      info\n      prospect\n      generalpublications\n    }\n  }\n  documentlabels {\n    labels {\n      key\n    }\n    documentLabelsTitle\n    ...OtherDocuments_documentLabels\n  }\n  livefilter {\n    ...LiveFilter_liveFilter\n  }\n  detailfilter {\n    ...DetailFilter_detailFilter\n    id\n  }\n  subscriptionfilter {\n    ...DetailFilter_detailFilter\n    id\n  }\n  languagepreference {\n    currentselection\n    ...LanguagePreference_component\n    id\n  }\n  filterbuttontext\n  filterbuttontextexpanded\n  noResultsMessage\n}\n\nfragment CategoryInfoEntry_entry on CategoryInfoEntry {\n  label\n  value\n}\n\nfragment CategoryInfo_info on CategoryInfo {\n  entries {\n    ...CategoryInfoEntry_entry\n  }\n}\n\nfragment DetailFilterDropdownCategory_category on DetailFilterDropdownCategory {\n  col\n  categoryname\n  info {\n    ...CategoryInfo_info\n  }\n  selectbox {\n    ...Selectbox_selectBox\n  }\n}\n\nfragment DetailFilterListCategory_category on DetailFilterListCategory {\n  col\n  categoryname\n  info {\n    ...CategoryInfo_info\n  }\n  filteritems {\n    label\n    filtervalue\n  }\n}\n\nfragment DetailFilterSelectionInfo_selectionInfo on DetailFilterSelectionInfo {\n  resetText\n  resultTextSingular\n  resultTextPlural\n}\n\nfragment DetailFilter_detailFilter on DetailFilter {\n  filtercategory {\n    __typename\n    ... on DetailFilterListCategory {\n      col\n      ...DetailFilterListCategory_category\n    }\n    ... on DetailFilterDropdownCategory {\n      col\n      ...DetailFilterDropdownCategory_category\n    }\n    id\n  }\n  selectioninfo {\n    ...DetailFilterSelectionInfo_selectionInfo\n  }\n}\n\nfragment FileLink_fileLink on FileLink {\n  header\n  text\n  url\n  date\n  format\n  size\n  smallicon\n  largeicon\n}\n\nfragment LanguagePreference_component on LanguagePreference {\n  info {\n    ...CategoryInfo_info\n  }\n  items {\n    label\n    filtervalue\n  }\n  categoryname\n}\n\nfragment LiveFilter_liveFilter on LiveFilter {\n  placeholder\n}\n\nfragment OtherDocuments_documentLabels on DocumentLabels {\n  labels {\n    key\n    label\n    shortlabel\n  }\n  documentLabelsTitle\n  furtherDocumentLabelsTitle\n  allDocumentLabelsTitle\n}\n\nfragment PriceInfo_component on PriceInfo {\n  tableheader {\n    col\n    label\n  }\n  title\n  file {\n    ...FileLink_fileLink\n  }\n  archive {\n    ...SimpleLink_simpleLink\n  }\n  checked\n}\n\nfragment Selectbox_selectBox on SelectBox {\n  options {\n    key\n    label\n    data\n  }\n}\n\nfragment SimpleLink_simpleLink on SimpleLink {\n  label\n  url\n}\n"
  }
};
})();

(node as any).hash = "417c321291cfc4701ea941c06802eb14";

export default node;
